import { render } from "./TestingDataReportParameters.vue?vue&type=template&id=801d8b3c"
import script from "./TestingDataReportParameters.vue?vue&type=script&lang=js"
export * from "./TestingDataReportParameters.vue?vue&type=script&lang=js"

import "./TestingDataReportParameters.vue?vue&type=style&index=0&id=801d8b3c&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__